var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',[_c('doctor-edit',{attrs:{"fetchClinicsBy":"admin","canDelete":true,"adminApprovalVar":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }